/*
 * @Author: Teemo Ding
 * @Date: 2021-09-30 13:41:56
 * @LastEditTime: 2021-10-08 17:03:43
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/tax.ts
 */
import { get, post } from 'src/tools/server';

export const init_salesChannelTaxData = (salesChannelUuid: string) => {
  return get<any>(`/portal/setting/salesChannel/tax/${salesChannelUuid}`, {});
};

export const save_salesChannelTaxData = (data) => {
  return post<any>(`/portal/setting/salesChannel/tax`, data || {}, {});
};
